// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gMWVN","importantInfo":"styles_importantInfo__2XA-T"};